import { Api } from '../api';
import {   IResponseLogUsuario, IResponseLogUsuarioPag, IResponseLogUsuarioRole } from 'shared/types';
import {   IResponseLogUsuarioOrg } from 'shared/types';

 


const getAllLogs = async (filter = ''): Promise<IResponseLogUsuario | Error> => {
  try{
   
    const { data, status } = await Api.get(`/UsuLog/${filter !== '' ? '?' : ''}${filter}`);   

    
    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAllLogsPag = async (usu_id: number): Promise<IResponseLogUsuarioPag | Error> => {
  try{
   
    const { data, status } = await Api.get(`/UsuLog/${usu_id}/10Ult`);   

    
    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getAllRoleLogs = async (idUsuario: number, filter = ''): Promise<IResponseLogUsuarioRole | Error> => {
  try{
    console.log(idUsuario);
    const { data, status } = await Api.get(`/UsuRoleLog/${idUsuario}/${filter !== '' ? '?' : ''}${filter}`);   
    
    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getLogUsuarioOrg = async (IdUsuario: number, filter = ''): Promise<IResponseLogUsuarioOrg | Error> => {
  try{
   
    const { data, status } = await Api.get(`/UsuOrgLog/${IdUsuario}/${filter !== '' ? '?' : ''}${filter}`);   

    
    if (data) {       
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id: string): Promise<IResponseLogUsuario | Error> => {
  try {
    const { data } = await Api.get(`/UsuLog/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};



export const LogService = {
  getAllRoleLogs,
  getAllLogs,
  getAllLogsPag,
  getById,
  getLogUsuarioOrg,
};
